import { MDBBtn, MDBContainer } from "mdb-react-ui-kit";
import { useEffect, useState, useMemo, useCallback } from "react";
import { columns } from "./columns";
import {
  convertISOToReadableDate,
  getMetadataAnalysis,
  showErrorToast,
} from "../../helpers";
import { MetadataAnalysisModal } from "./components/MetadataAnalysisReviewModal";
import ErrorMessage from "../../components/ErrorMessage/ErrorMessage";
import { CountCard } from "../../components";
import { exportMetadataAnalysisToExcel } from "./export";
import { DataTable } from "stm-frontend-library";
import { getSelectedJournalIds } from "../../helpers/journals";

const MetadataAnalysis = () => {
  const [error, setError] = useState(false);

  const [data, setData] = useState(null);
  const [totalHits, setTotalHits] = useState(0);

  const [selectedDataRowIndex, setSelectedDataRowIndex] = useState(null);
  const [isLoading, setIsLoading] = useState(false);

  const handleRowClick = useCallback((index) => {
    setSelectedDataRowIndex(index);
  }, []);

  const handleCloseModal = () => setSelectedDataRowIndex(null);

  useEffect(() => {
    const fetchData = async () => {
      try {
        setIsLoading(true);
        setError(false);
        const selectedJournalIds = await getSelectedJournalIds();
        const { data: { manuscripts = [], total = 0 } = {} } =
          await getMetadataAnalysis(selectedJournalIds);
        setData(manuscripts);
        setTotalHits(total);
      } catch (error) {
        showErrorToast();
        setError(true);
      } finally {
        setIsLoading(false);
      }
    };

    fetchData();
  }, []);

  const dataWithActions = useMemo(() => {
    if (!data) return [];

    return data.map((element, index) => ({
      ...element,
      timestamp: convertISOToReadableDate(element.timestamp, "DD MMM YYYY"),
      clickEvent: () => handleRowClick(index),
    }));
  }, [data, handleRowClick]);

  const handleExport = () => {
    exportMetadataAnalysisToExcel(dataWithActions, "MetadataAnalysis");
  };

  return (
    <MDBContainer className="my-5">
      {selectedDataRowIndex !== null && (
        <MetadataAnalysisModal
          contentData={data[selectedDataRowIndex]}
          onClose={handleCloseModal}
        />
      )}
      {error && <ErrorMessage />}
      {!error && (
        <>
          <div className="d-flex justify-content-center m-5">
            <CountCard
              count={totalHits}
              title={"ANALYSIS SIGNALS"}
              subtitle={"Screened manuscripts with hits"}
            />
          </div>
          <div className="d-flex justify-content-end mb-3">
            <MDBBtn
              disabled={isLoading}
              color="primary"
              className="px-4"
              onClick={handleExport}
            >
              Export
            </MDBBtn>
          </div>
          <DataTable
            columns={columns}
            rows={dataWithActions}
            isLoading={isLoading}
          />
        </>
      )}
    </MDBContainer>
  );
};

export default MetadataAnalysis;
